import { Suspense, type ReactNode } from "react";
import { useLocation } from "@/router/Router";
import { useAuth } from "@/state/AuthProvider";
import { MemberWorkspace } from "./MemberWorkspace";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { FloatingActions } from "./FloatingActions";
import { ErrorBoundary } from "./ErrorBoundary";

function PageFallback() {
  return (
    <div className="page-loading" role="status" aria-label="Loading page">
      <span className="page-loading__bar" />
      <div className="page-loading__content"><span className="page-loading__symbol" aria-hidden="true" /><strong>Getting things ready…</strong><p>Your church family is just a moment away.</p><div className="page-loading__tiles" aria-hidden="true"><span /><span /><span /></div></div>
    </div>
  );
}

export function Layout({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const { user } = useAuth();
  if (user && pathname !== "/welcome") return <MemberWorkspace><ErrorBoundary label="page" resetKey={pathname}><Suspense fallback={<PageFallback />}>{children}</Suspense></ErrorBoundary></MemberWorkspace>;
  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      {pathname !== "/account" && <Header />}
      <main id="main" tabIndex={-1} className="site-main">
        <ErrorBoundary label="page" resetKey={pathname}>
          <Suspense fallback={<PageFallback />}>
            <div className="page-transition" key={pathname}>
              {children}
            </div>
          </Suspense>
        </ErrorBoundary>
      </main>
      {pathname !== "/account" && <Footer />}
      <FloatingActions />
    </>
  );
}
